<span><span v-if="RAG=='W'" v-html="blank"></span><icon v-else :name="iconConfig.name" :color="iconConfig.color"></icon></span>